import { Button } from "@shapr3d/frontend-lib";

import { useTracker } from "../../../../hooks/useTracker";
import { ElementClickAction, ElementClickLocation } from "../../../../lib/TrackingAdapter";
import { navigateToAuth } from "../../../../utils/authUtils";

export const LoginButton = ({ variant = "primary" }: { variant?: "primary" | "soft" }) => {
  const tracker = useTracker();

  return (
    <Button
      aria-label="login"
      variant={variant}
      onClick={() => {
        tracker.trackButtonClick({
          action: ElementClickAction.LOGIN,
          location: ElementClickLocation.HEADER,
        });
        navigateToAuth();
      }}
    >
      Log in
    </Button>
  );
};
